import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const figures = [
  { value: '341+', label_fr: 'HECTARES', label_en: 'HECTARES' },
  { value: '5', label_fr: 'PROJETS STRUCTURANTS', label_en: 'KEY PROJECTS' },
  { value: '15+', label_fr: 'EXPERTS MOBILISÉS', label_en: 'EXPERTS ENGAGED' },
];

const KeyFigures = () => {
  const { language } = useLanguage();

  return (
    <div
      className="absolute bottom-0 left-0 right-0 z-20"
      data-testid="key-figures-section"
    >
      <div
        className="w-full"
        style={{
          backgroundColor: 'rgba(250, 249, 246, 0.95)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
        }}
      >
        <div className="max-w-5xl mx-auto flex items-center justify-center">
          {figures.map((fig, i) => (
            <div key={`fig-${fig.value}`} className="flex items-center">
              {/* Separator */}
              {i > 0 && (
                <div
                  className="h-10 w-px mx-0"
                  style={{ backgroundColor: '#c4a76c' }}
                  data-testid={`key-figure-sep-${i}`}
                />
              )}

              {/* Figure block */}
              <div
                className="flex items-center gap-3 px-6 sm:px-10 py-4"
                data-testid={`key-figure-block-${i}`}
              >
                <span
                  className="text-xl sm:text-2xl"
                  style={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontWeight: 300,
                    color: '#c4a76c',
                    letterSpacing: '0.5px',
                  }}
                  data-testid={`key-figure-value-${i}`}
                >
                  {fig.value}
                </span>
                <span
                  className="text-[11px] sm:text-xs"
                  style={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontWeight: 700,
                    color: '#1e4a1a',
                    letterSpacing: '0.1em',
                    textTransform: 'uppercase',
                  }}
                  data-testid={`key-figure-label-${i}`}
                >
                  {language === 'fr' ? fig.label_fr : fig.label_en}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KeyFigures;
